import React, { useState, useEffect } from "react";
import PayoutDashboard from "../../components/payout/index";
import CustomLandingBody from "../../components/customLandingBody";
import { triggerIsDashboardAccessible, unsetRun } from "../../redux/actions";
import Spinner from "../../components/presentationals/Spinner";
import { useDispatch, useSelector } from "react-redux";

const ActivationPayout = () => {
  const { getAllAPI, filterValue, tilesData } = useSelector(
    (state) => state.homeReducer
  );

  const { dashboardAccessibility } = useSelector(
    (state) => state?.dashboardAccessibilityReducer
  );

  const dispatch = useDispatch();

  const [showAlert, setShowAlert] = useState(null);
  const [dashboardName, setDashboardName] = useState("Activation Payout");

  useEffect(() => {
    //check if isTestingActive is true, then send api call for triggerIsDashboardAccessible
    let isTestingActive = tilesData?.data?.content?.filter(
      (obj) => obj.moduleName === dashboardName
    )[0].isTestingActive;

    //if it is true, then check if this loggedin user has access to this dashboard
    if (isTestingActive) {
      //to check if the response for this dashboard api call is already cached in redux
      let isExistingDashboard = dashboardAccessibility?.data?.filter(
        (currentDashboard) => currentDashboard.dashboard === dashboardName
      );

      //if dashboard accessibility is already cached and accessEnabled is false, means directly show alert without sending api call again
      if (
        isExistingDashboard.length > 0 &&
        !isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        // load dashboardcard home component and show alert
        return setShowAlert(true);
      }

      // if dashboard accessibility is cached and accessEnabled is true, do not send api call, do not show alert BUT SHOW DASHBOARD NORMALLY
      else if (
        isExistingDashboard.length > 0 &&
        isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        setShowAlert(false);
      }

      //if dashboard accessibility is not cached already then send api call for this dashboard
      else {
        const data = {
          baseParameter: {
            name: dashboardName,
            userType: this.props.filterValue.site
          },
          domainId:
            filterValue.orgId !== "" ? filterValue.orgId : filterValue?.agentId,
        };

        const obj = {
          headers: {
            "Content-Type": "application/json",
            url: "get-dashboard-user-role-mapping",
          },
          params: data,
          extraData: "get-dashboard-user-role-mapping",
        };

        return dispatch(
          triggerIsDashboardAccessible(obj, (res) => {
            //if the response shows access enabled as false, go to home page and show alert
            if (!res.content.accessEnabled) {
              setShowAlert(true);
            } else {
              setShowAlert(false);
            }
          })
        );
      }
    }

    //if isTestingActive is false, it is open for all users
    else {
      setShowAlert(false);
    }
  }, [getAllAPI]);

  useEffect(() => {
    dispatch(unsetRun());
  }, []);

  return showAlert === null ? (
    <Spinner />
  ) : showAlert ? (
    <CustomLandingBody showAlert={showAlert} dashboardName={dashboardName} />
  ) : (
    <div>
      <PayoutDashboard component="activation" dashboardName={dashboardName} />
    </div>
  );
};

export default ActivationPayout;
